<template>
  <a class="detail-icon" :href="href()"
    onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
    <svg><use xlink:href="#twitter"></use></svg>
  </a>
</template>

<style scoped>
</style>

<script>
export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
    },

    methods: {
        href: function () {
            return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.description) +
                '&url=' + encodeURIComponent(this.url)
        }
    },
}
</script>
